// ModelSelectionScreen.jsx

import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../index.css";
import { trackFunnelStepComplete, trackFunnelStepView } from "../utils/analytics";
import ValuationFrame from "./ValuationFrame";

function ModelSelectionScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    trackFunnelStepView(2, "model_selection");
  }, []);

  const handleSelect = (type) => {
    localStorage.setItem("type", type);
    trackFunnelStepComplete(2, "model_selection");
    navigate("/region-selection");
  };

  const handleComingSoon = () => {
    alert(
      "This model is coming soon.\n\n" +
        "If your need is urgent, please contact us at admin@skywardinnovation.com.\n" +
        "For now, use the Operating/Stabilized model and treat the result as preliminary."
    );
  };

  return (
    <ValuationFrame
      currentStep={1}
      title="Select the Valuation Model"
      subtitle="The current public workflow supports operating or stabilized hotel assets. Development and conversion cases can be handled later through a more tailored review."
    >
      <div className="button-group">
        <button
          type="button"
          onClick={() => handleSelect("Operating/Stabilized")}
          className="button"
        >
          Operating/Stabilized
        </button>

        <button
          type="button"
          onClick={handleComingSoon}
          className="button secondary-button"
        >
          Upgrade/Development/Conversion
        </button>
      </div>
    </ValuationFrame>
  );
}

export default ModelSelectionScreen;
